module.exports = __webpack_public_path__ + "static/sport/bg.4eccb9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/bg.png
// module id = HDIy
// module chunks = 0